var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKava(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 100,
    fill: "#FF443F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157 156.605C155.453 156.778 154.517 156.968 153.582 156.968C146.817 156.968 140.051 157.072 133.298 156.905C131.889 156.826 130.569 156.203 129.627 155.173C115.743 137.517 101.977 119.757 88.1407 102.072C86.5994 100.115 86.6229 98.8744 88.1937 96.8774C101.96 79.3829 115.561 61.7557 129.327 44.2612C130.344 43.0581 131.801 42.2953 133.386 42.1371C140.334 41.9178 147.299 42.0217 154.253 42.0448C155.161 42.1356 156.06 42.2977 156.941 42.5296C156.247 43.6263 155.818 44.4343 155.265 45.15C141.93 62.4964 128.586 79.8273 115.231 97.1429C113.855 98.9206 113.873 100.087 115.231 101.87C128.637 119.151 141.987 136.467 155.282 153.817C155.818 154.556 156.206 155.317 157 156.605Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9181 99.6358C76.9181 117.517 76.8482 135.363 76.9822 153.226C76.9822 156.191 76.0211 157.091 73.1669 156.993C68.4254 156.82 63.6665 156.872 58.9134 156.935C56.8863 156.935 55.966 156.405 56.001 154.161C56.0514 117.765 56.0514 81.3647 56.001 44.9608C56.001 42.8094 56.8456 42.0768 58.9134 42.0768C63.7597 42.1287 68.6176 42.2037 73.4756 42.0076C76.388 41.8922 77.0171 43.0862 76.9996 45.7395C76.9065 63.7011 76.953 81.6627 76.953 99.6243L76.9181 99.6358Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKava);
export default __webpack_public_path__ + "static/media/kava.b5214eb8f9b0812240ecdd19d6b9e332.svg";
export { ForwardRef as ReactComponent };